import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder, AbstractControl } from '@angular/forms';
import jwtDecode from 'jwt-decode';
import { LoginService } from 'src/app/core/services/login.service';
import { ProfileService } from '../../services/profile.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { VerifyOtpComponent } from '../verify-otp/verify-otp.component';
import { ToastService } from 'src/app/core/toast.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MediaService } from 'src/app/shared/modules/services/media.service';
import { SlsService } from 'src/app/core/services/sls.service';
import { MapsAPILoader } from '@agm/core';
import { BusinessTyesService } from 'src/app/modules/sign-up/services/business-tyes.service';
import { SelectProfessionTypeComponent } from 'src/app/modules/sign-up/components/select-profession-type/select-profession-type.component';
import { Router } from '@angular/router';
import { IncomProfComponent } from 'src/app/modules/sign-up/components/incom-prof/incom-prof.component';
import { BasicInfoTabService } from 'src/app/modules/dashboard/modules/my-directory/services/basic-info-tab.service';
import { FeedService } from 'src/app/modules/feeds/services/feed.service';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { Tables } from 'src/app/shared/enum/tables.enum';
import { LogoutService } from 'src/app/core/services/logout.service';
import { Overlay } from '@angular/cdk/overlay';
@Component({
  selector: 'app-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.scss']
})
export class ProfileDetailsComponent implements OnInit {
  token: any;
  butDisabled: boolean = true;
  signUpDetailsForm: FormGroup;
  subscriberDetailForm: FormGroup;
  contactInformationForm: FormGroup;
  professionalDetailsForm: FormGroup;
  otherDetailsForm: FormGroup
  statusMsg: any;
  userPhoto: any;
  phoneBlock: boolean = true;
  nameBlock: boolean = true;
  bankOneBlock: boolean = true;
  conBlock: boolean = true;
  emailrequire: boolean = false;
  maxDOB: Date = new Date(); 
  busineesTypes: any;
  showDeleteModal: boolean = false;
  selectedReason: string = '';
  otherReason: string = '';
  clientId: string;
  // bankTwoBlock:boolean = true;
  // bankThreeBlock:boolean = true;
  // bankFourBlock:boolean = true;
  updatePhone = {
    phone: null
  };
  updateName = {
    name: null
  };
  profImage = {
    profile_image: null
  }
  suppImage = {
    logo: null
  }
  pracImage = {
    logo: null
  }
  /* --------------------------------- FIELDS -------------------------------- */
  userForm: FormGroup = this.fb.group({
    // profileImage: [null],
    fName: [null, [Validators.required]],
    lName: [null, [Validators.required]],
    email: [null, [Validators.required]],
    phone: [null, [Validators.required]],
    password: [null, [Validators.required]],
    confirmPassword: [null, [Validators.required]],
    altEmail: [null, [Validators.required]],
    altPhone: [null, [Validators.required]],
    addLine1: [null, [Validators.required]],
    addLine2: [null, [Validators.required]],
    landmark: [null, [Validators.required]],
    city: [null, [Validators.required]],
    state: [null, [Validators.required]],
    country: [null, [Validators.required]],
    zipCode: [null, [Validators.required]],
    drivingLicense: [null, [Validators.required]],
    regNumber: [null, [Validators.required]],
    profession_type: [null, [Validators.required]],
    bankName: [null, [Validators.required]],
    accountName: [null, [Validators.required]],
    accountNumber: [null, [Validators.required]],
    bsb: [null, [Validators.required]],
    // phone: [null, [ Validators.pattern(/^(\+91)[1-9]{1}[0-9]{9}/)]],
    // isProfileCompleted: [true]
  });
  mobileForm: FormGroup = this.fb.group({
    mobile: ['+91', [Validators.required, Validators.pattern(/^(\+91)[1-9]{1}[0-9]{9}/)]]
  });
  verifyForm: FormGroup = this.fb.group({
    code: [null, [Validators.required]]
  });
  oldProfile: any;
  userDetails: any;
  userDisplay: any = [{
    second_hand: false
  }];
  phoneObj = {
    email: null,
    type: null
  }
  contactProf = {
    alt_email: null,
    alt_phone: null,
    address: null,
  }
  contactSupp = {
    alt_phone: null,
    alt_email: null,
    business_email: null,
    business_phone: null,
    secondary_name: null,
    secondary_email: null,
    secondary_phone: null

  }
  bankDetails = {
    bank_details: {
      bank_name: null,
      account_number: null,
      account_holder_name: null,
      bsb: null
    },
    second_hand: null
  }
  // confirmationResult: firebase.auth.ConfirmationResult;
  otherBlock: boolean = true
  showMobileLinkSection: any;
  userProfileData: any;
  userData: any;



  @ViewChild('addressSearch') addressSearchElementRef: ElementRef;
  latitude: number;
  longitude: number;
  zoom: number;
  private geoCoder;
 loginDetails: any;

  constructor(
    private fb: FormBuilder,
    private profileService: ProfileService,
    private loginService: LoginService,
    private logoutService : LogoutService,
    private _fb: FormBuilder,
    private _dialog: MatDialog,
    private toast: ToastService,
    private spinner: NgxSpinnerService,
    private mediaService: MediaService,
    private sls: SlsService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private businessTyesService: BusinessTyesService,
    private router: Router,
    private basicInfoTabService: BasicInfoTabService,
    private feedService: FeedService,
    private CommonService:CommonServicesForAllModules,
    private overlay: Overlay
  ) { }
  ngOnInit(): void {
    this.token = this.loginService.getLoginData();
    console.log("Profile Details Token-------------------", this.token);
    this.clientId = this.token.id;
    this.loginDetails = this.sls.get('loginData');
     this.loadUserProfile();

    this.subscriberDetailForm = this._fb.group({
      salutation: [null, [Validators.required]],
      // first_name: [null, [Validators.required]],
      name: [null, [Validators.required]],
      last_name: [null, [Validators.required]],
      middle_name: [null],
      date_of_birth: [null, [Validators.required]],
      gender: [null, [Validators.required]],
      profile_image: [null],
      businessLogo: [null],
      businessName: [null, [Validators.required]],
      ABN_ACN_number: [null, [Validators.required]],
    });
    this.signUpDetailsForm = this._fb.group({
      name: [null, [Validators.required]],
      email: [null, [Validators.required]],
      phone: [null, [Validators.required, Validators.pattern(/^[0-9]{10}$/)]]
      //type: [null, [Validators.required]]
    });
    this.phone.disable();
    this.name.disable();
    this.contactInformationForm = this._fb.group({
      // fName: [null, [Validators.required]],
      lName: [null, [Validators.required]],
      mName: [null, [Validators.required]],
      businessPhoneNumber: [null],
      //emailtwo: [null, [Validators.required]],
      //phoneNo: [null, [Validators.required]],
      altEmail: [null, [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)]],
      altPhoneNo: [null, [Validators.pattern(/^[0-9]{10,15}$/)]],
      address: [null, [Validators.required]],
      address_line_one: [null, [Validators.required]],
      address_line_two: [null],
      land_mark: [null, [Validators.required]],
      city: [null, [Validators.required]],
      state: [null, [Validators.required]],
      country: [null, [Validators.required]],
      zipcode: [null, [Validators.required]],
      businessEmail: [null, [Validators.required]],
      faxNumber: [null, [Validators.required]],
      emailTwo: [null, [Validators.required]],
      phoneNoTwo: [null, [Validators.required]],
      contactName: [null, [Validators.required]],
    });
    this.businessPhoneNumber.disable();
    this.altEmail.disable();
    this.altPhoneNo.disable();
    this.businessEmail.disable();
    this.professionalDetailsForm = this._fb.group({
      profession_type: [null, [Validators.required]],
      pro_details_aphra_registration_number: ['', [Validators.required, Validators.minLength(13), Validators.maxLength(13)]],
      drivingLicense: [null, [Validators.required]],
      tga: [null, [Validators.required]],
      // dentalCertificate: [null, [Validators.required]],
      // hourly_charge_in_aud: [null, [Validators.required]],
      // hourly_charge_in_usd: [null, [Validators.required]],
      // areas_of_interest: [null, [Validators.required]],
      // registration_certificate_attachment: [null, , [Validators.required]],
      // doctorLicense: [null, [Validators.required]],
      // resume_attachment: [''],
      // bank_name: [null, [Validators.required]],
      // branch_name: [null, [Validators.required]],
      // account_holder_name: [null, [Validators.required]],
      // account_number: [null, [Validators.required]],
      // bsb: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
    });
    this.otherDetailsForm = this._fb.group({
      sellSecondHandSupplies: [null],
      sellProducts: [null],
      bank_name: [null, [Validators.required]],
      //branch_name: [null, [Validators.required]],
      account_holder_name: [null, [Validators.required]],
      account_number: [null, [Validators.required]],
      bsb: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
    });
    this.bank_name.disable();
    this.account_holder_name.disable();
    this.account_number.disable();
    this.bsb.disable();
    this.token = this.sls.get('loginData');
    console.log("Profile details token", this.token);
    if (this.token.type == "SUPPLIER") {
      console.log("I came here");
      this.profileService.getSupplierDisplay(this.token.id).subscribe(data => {
        console.log("Profile Details 1212--->", data)
        this.userDisplay = data
        console.log('userDisplay------------SUPPLIER', this.userDisplay);

        this.signUpDetailsForm.patchValue({
          email: this.userDisplay.email,
          phone: this.userDisplay.phone,
          name: this.userDisplay.name
        });
        this.subscriberDetailForm.patchValue({
          ABN_ACN_number: this.userDisplay.abn_number,
          businessName: this.userDisplay.business_name,
          name: this.userDisplay.name
          // name: this.userDisplay.name,
          // first_name: this.userDisplay.first_name,
          // last_name: this.userDisplay.last_name,
          // middle_name: this.userDisplay.middle_name,
          // date_of_birth:this.userDisplay.date_of_birth,
          // gender:this.userDisplay.gender,
          // salutation:this.userDisplay.salutation
        });
        console.log('Full contactInformationForm--->SUPPLIER', this.contactInformationForm)

        const fullAddress = this.userDisplay?.address || '';

        // Watch the 'address' field
        this.contactInformationForm.get('address')?.valueChanges.subscribe((fullAddress: string) => {
          if (!fullAddress) {
            // Clear all other address fields if 'address' is empty
            this.contactInformationForm.patchValue({
              address_line_one: '',
              address_line_two: '',
              land_mark: '',
              city: '',
              state: '',
              zipcode: '',
              country: ''
            }, { emitEvent: false }); // avoid infinite loop
          } else if (this.geoCoder) {
            // Run your existing geocoding logic
            this.geoCoder.geocode({ address: fullAddress }, (results, status) => {
              if (status === 'OK' && results[0]) {
                const components = results[0].address_components;
                const getComponent = (types: string[]) =>
                  components.find(c => types.some(t => c.types.includes(t)))?.long_name || '';

                const streetNumber = getComponent(['street_number']);
                const route = getComponent(['route']);
                const addressLine1 = [streetNumber, route].filter(Boolean).join(' ').trim();

                const addressLine2 = getComponent(['subpremise', 'sublocality_level_1', 'sublocality', 'neighborhood']);
                let landmark = getComponent(['sublocality_level_2', 'subpremise', 'premise']);
                if (!landmark) landmark = addressLine2;

                const city = getComponent(['locality']);
                const state = getComponent(['administrative_area_level_1']);
                const postalCode = getComponent(['postal_code']);
                const country = getComponent(['country']);

                this.contactInformationForm.patchValue({
                  address_line_one: addressLine1,
                  address_line_two: addressLine2,
                  land_mark: landmark,
                  city,
                  state,
                  zipcode: postalCode,
                  country
                }, { emitEvent: false });
              }
            });
          }
        });



        this.contactInformationForm.patchValue({
          altEmail: this.userDisplay.alt_email,
          altPhoneNo: this.userDisplay.alt_phone,

          // address_line_one: this.userDisplay?.address?.address_line_one,
          // address_line_two: this.userDisplay?.address?.address_line_two,
          // address: this.userDisplay?.address?.addressName,
          // // address_line_two:this.userData.payload.address.address_line_two,
          // state: this.userDisplay?.address?.state,
          // city: this.userDisplay?.address?.city,
          // country: this.userDisplay?.address?.country,
          // zipcode: this.userDisplay?.address?.zipcode,
          // land_mark: this.userDisplay?.address?.land_mark,
          address: fullAddress,

          businessEmail: this.userDisplay?.business_email,
          faxNumber: this.userDisplay?.fax_number,
          businessPhoneNumber: this.userDisplay?.business_phone,
          contactName: this.userDisplay?.secondary_contact?.name,
          emailTwo: this.userDisplay?.secondary_contact?.email,
          phoneNoTwo: this.userDisplay?.secondary_contact?.phone,
          fName: this.userDisplay?.name,
          lName: this.userDisplay?.last_name,
          mName: this.userDisplay?.middle_name,
        });





        this.professionalDetailsForm.patchValue({
          // profession_type: this.userDisplay.profession_type,
          // profession_type: this.userDisplay.profession_type || '',
          profession_type: this.userDisplay.profession_type || this.userDisplay.directories?.[0]?.profession_type || '',
          // pro_details_aphra_registration_number: this.userData.payload.pro_details_aphra_registration_number,
          // drivingLicense: this.userData.payload.drivingLicense,
          tga: this.userDisplay.tga_number
        });
        this.otherDetailsForm.patchValue({
          sellSecondHandSupplies: this.userDisplay.second_hand,
          sellProducts: this.userDisplay.sell_products,
          //  sellProducts:[null],
          bank_name: this.userDisplay?.bank_details?.bank_name,
          //branch_name: [null, [Validators.required]],
          account_holder_name: this.userDisplay?.bank_details?.account_holder_name,
          account_number: this.userDisplay?.bank_details?.account_number,
          bsb: this.userDisplay?.bank_details?.bsb,
        })
      })

      /**** preview basic info end*/
      this.businessTyesService.getBusinessTYpes(this.token.type).subscribe(data => {
        console.log(data)
        this.busineesTypes = data
        console.log("Business Types", this.busineesTypes);
      });
    }

    if (this.token.type == "PRACTICE") {
      this.profileService.getPracticeDisplay(this.token.id).subscribe(data => {
        console.log(data)
        this.userDisplay = data
        console.log('userDisplay------PRACTICE', this.userDisplay)
        console.log('subscriberDetailForm------PRACTICE', this.subscriberDetailForm)
        this.signUpDetailsForm.patchValue({
          email: this.userDisplay.email,
          phone: this.userDisplay.phone,
          name: this.userDisplay.name
        });
        this.subscriberDetailForm.patchValue({
          ABN_ACN_number: this.userDisplay.abn_number,
          businessName: this.userDisplay.business_name,
          name: this.userDisplay.name,


          //   first_name: this.userDisplay.first_name,
          //   last_name: this.userDisplay.last_name,
          //   middle_name: this.userDisplay.middle_name,
          // //  date_of_birth:this.userDisplay.date_of_birth,
          //   gender:this.userDisplay.gender,
          //   salutation:this.userDisplay.salutation
        });


        const fullAddress = this.userDisplay?.address || '';

        // Watch the 'address' field
        this.contactInformationForm.get('address')?.valueChanges.subscribe((fullAddress: string) => {
          if (!fullAddress) {
            // Clear all other address fields if 'address' is empty
            this.contactInformationForm.patchValue({
              address_line_one: '',
              address_line_two: '',
              land_mark: '',
              city: '',
              state: '',
              zipcode: '',
              country: ''
            }, { emitEvent: false }); // avoid infinite loop
          } else if (this.geoCoder) {
            // Run your existing geocoding logic
            this.geoCoder.geocode({ address: fullAddress }, (results, status) => {
              if (status === 'OK' && results[0]) {
                const components = results[0].address_components;
                const getComponent = (types: string[]) =>
                  components.find(c => types.some(t => c.types.includes(t)))?.long_name || '';

                const streetNumber = getComponent(['street_number']);
                const route = getComponent(['route']);
                const addressLine1 = [streetNumber, route].filter(Boolean).join(' ').trim();

                const addressLine2 = getComponent(['subpremise', 'sublocality_level_1', 'sublocality', 'neighborhood']);
                let landmark = getComponent(['sublocality_level_2', 'subpremise', 'premise']);
                if (!landmark) landmark = addressLine2;

                const city = getComponent(['locality']);
                const state = getComponent(['administrative_area_level_1']);
                const postalCode = getComponent(['postal_code']);
                const country = getComponent(['country']);

                this.contactInformationForm.patchValue({
                  address_line_one: addressLine1,
                  address_line_two: addressLine2,
                  land_mark: landmark,
                  city,
                  state,
                  zipcode: postalCode,
                  country
                }, { emitEvent: false });
              }
            });
          }
        });

        this.contactInformationForm.patchValue({
          altEmail: this.userDisplay.alt_email,
          altPhoneNo: this.userDisplay.alt_phone,

          // address_line_one: this.userDisplay?.address?.address_line_one,
          // address_line_two: this.userDisplay?.address?.address_line_two,
          // address_line_two:this.userData.payload.address.address_line_two,
          // state: this.userDisplay?.address?.state,
          // city: this.userDisplay?.address?.city,
          // address: this.userDisplay?.address?.addressName,
          // country: this.userDisplay?.address?.country,
          // zipcode: this.userDisplay?.address?.zipcode,
          // land_mark: this.userDisplay?.address?.land_mark,

          address: fullAddress,

          businessEmail: this.userDisplay?.business_email,
          faxNumber: this.userDisplay?.fax_number,
          businessPhoneNumber: this.userDisplay?.business_phone,
          contactName: this.userDisplay?.secondary_contact?.name,
          emailTwo: this.userDisplay?.secondary_contact?.email,
          phoneNoTwo: this.userDisplay?.secondary_contact?.phone,
          fName: this.userDisplay?.first_name,
          lName: this.userDisplay?.last_name,
          mName: this.userDisplay?.middle_name
        });
        this.professionalDetailsForm.patchValue({
          // profession_type: this.userDisplay.profession_type,
          profession_type: this.userDisplay?.profession_type || this.userDisplay?.directories?.[0]?.profession_type || '',


          pro_details_aphra_registration_number: this.userDisplay?.pro_details_aphra_registration_number,
          drivingLicense: this.userDisplay?.driving_licence,
          tga: this.userDisplay?.tga_number
        });
        this.otherDetailsForm.patchValue({
          sellSecondHandSupplies: this.userDisplay?.second_hand,
          //  sellProducts:[null],
          bank_name: this.userDisplay?.bank_details?.bank_name,
          //branch_name: [null, [Validators.required]],
          account_holder_name: this.userDisplay?.bank_details?.account_holder_name,
          account_number: this.userDisplay?.bank_details?.account_number,
          bsb: this.userDisplay?.bank_details?.bsb,
        })
      })
      /**** preview basic info end*/
      this.businessTyesService.getBusinessTYpes(this.token.type).subscribe(data => {
        console.log(data)
        this.busineesTypes = data
        console.log("Business Types", this.busineesTypes);
      });
    }
    if (this.token.type == "PROFESSIONAL") {


      this.profileService.getProfDisplay(this.token.id).subscribe(data => {
        this.userDisplay = data

        console.log('userDisplay-- PROFESSIONAL', this.userDisplay);
        console.log('signUpDetailsForm-- PROFESSIONAL', this.signUpDetailsForm);
        console.log('subscriberDetailForm-- PROFESSIONAL', this.subscriberDetailForm);
        console.log('contactInformationForm-- PROFESSIONAL', this.contactInformationForm);
        console.log('professionalDetailsForm-- PROFESSIONAL', this.professionalDetailsForm);

        this.signUpDetailsForm.patchValue({
          email: this.userDisplay.email,
          phone: this.userDisplay.phone,
          name: this.userDisplay.name

        });
        this.subscriberDetailForm.patchValue({
          //  ABN_ACN_number:this.userDisplay.abn_number,
          //  businessName:this.userDisplay.business_name,
          name: this.userDisplay.name,
          // first_name: this.userDisplay.first_name,
          last_name: this.userDisplay.last_name,
          middle_name: this.userDisplay.middle_name,
          date_of_birth: this.userDisplay.date_of_birth,
          gender: this.userDisplay.gender,
          salutation: this.userDisplay.salutation
        });

        const fullAddress = this.userDisplay?.address || '';

        // Watch the 'address' field
        this.contactInformationForm.get('address')?.valueChanges.subscribe((fullAddress: string) => {
          if (!fullAddress) {
            // Clear all other address fields if 'address' is empty
            this.contactInformationForm.patchValue({
              address_line_one: '',
              address_line_two: '',
              land_mark: '',
              city: '',
              state: '',
              zipcode: '',
              country: ''
            }, { emitEvent: false }); // avoid infinite loop
          } else if (this.geoCoder) {
            // Run your existing geocoding logic
            this.geoCoder.geocode({ address: fullAddress }, (results, status) => {
              if (status === 'OK' && results[0]) {
                const components = results[0].address_components;
                const getComponent = (types: string[]) =>
                  components.find(c => types.some(t => c.types.includes(t)))?.long_name || '';

                const streetNumber = getComponent(['street_number']);
                const route = getComponent(['route']);
                const addressLine1 = [streetNumber, route].filter(Boolean).join(' ').trim();

                const addressLine2 = getComponent(['subpremise', 'sublocality_level_1', 'sublocality', 'neighborhood']);
                let landmark = getComponent(['sublocality_level_2', 'subpremise', 'premise']);
                if (!landmark) landmark = addressLine2;

                const city = getComponent(['locality']);
                const state = getComponent(['administrative_area_level_1']);
                const postalCode = getComponent(['postal_code']);
                const country = getComponent(['country']);

                this.contactInformationForm.patchValue({
                  address_line_one: addressLine1,
                  address_line_two: addressLine2,
                  land_mark: landmark,
                  city,
                  state,
                  zipcode: postalCode,
                  country
                }, { emitEvent: false });
              }
            });
          }
        });


        // Patch raw address first
        this.contactInformationForm.patchValue({ address: fullAddress });





        this.professionalDetailsForm.patchValue({
          // profession_type: this.userDisplay.profession_type,
          profession_type: this.userDisplay.profession_type || this.userDisplay.directories?.[0]?.profession_type || '',
          pro_details_aphra_registration_number: this.userDisplay.pro_details_aphra_registration_number,


        });
        this.otherDetailsForm.patchValue({
          sellSecondHandSupplies: this.userDisplay.second_hand,
          //  sellProducts:[null],
          bank_name: this.userDisplay.bank_details?.bank_name,
          //branch_name: [null, [Validators.required]],
          account_holder_name: this.userDisplay.bank_details?.account_holder_name,
          account_number: this.userDisplay.bank_details?.account_number,
          bsb: this.userDisplay.bank_details?.bsb,
        })
      })

      /**** preview basic info end*/
      this.businessTyesService.getBusinessTYpes(this.token.type).subscribe(data => {
        console.log(data)
        this.busineesTypes = data
        console.log("Business Types", this.busineesTypes);
      });

    }
    //console.log(resData)
    // //this.token = jwtDecode(localStorage.getItem("accessToken"));
    // console.log(this.token)
    //  if(this.token.type == "PRACTICE"){
    //   this.profileService.getUserProfilePracice(this.token.id).subscribe(data=>{
    //     this.userProfileData = data
    //     console.log(this.userProfileData)
    //     this.userForm.patchValue({
    //       email:this.userProfileData.email,
    //       phone:this.userProfileData.phone
    //     })
    //   })
    // }
    // if(this.token.type == "PROFESSIONAL"){
    //   this.profileService.getUserProfileProfessional(this.token.id).subscribe(data=>{
    //     this.userProfileData = data
    //     console.log(this.userProfileData)
    //     this.userForm.patchValue({
    //       email:this.userProfileData.email,
    //       phone:this.userProfileData.phone,
    //       fName:this.userProfileData.first_name,
    //       lName:this.userProfileData.last_name
    //     })
    //   })
    // }
    // if(this.token.type === "SUPPLIER"){
    //   this.profileService.getUserProfileSuplier(this.token.id).subscribe(data=>{
    //     this.userProfileData = data
    //     console.log(this.userProfileData)
    //     // this.userForm.patchValue({
    //     //   email:this.userProfileData.email,
    //     //   phone:this.userProfileData.phone
    //     // })
    //   })
    // }

    /** spinner starts on init */
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 1000);
  }

  openModal() {
    this.showDeleteModal = true;
  }

  closeModal() {
    this.showDeleteModal = false;
  }

  async submitDelete() {
   this.spinner.show();
    try {
      const userId = this.token.id;
      const userType = this.token.type;

      await this.CommonService.DeleteById(Tables.Clients, userId);

      if (userType === 'SUPPLIER') {
        await this.CommonService.DeleteById(Tables.DentalSuppliers, userId);
        await this.CommonService.DeleteByCondition(Tables.Directories, {
          dental_supplier_id: { _eq: userId }
        });

      } else if (userType === 'PRACTICE') {
        await this.CommonService.DeleteById(Tables.DentalPractices, userId);
        await this.CommonService.DeleteByCondition(Tables.Directories, {
          dental_practice_id: { _eq: userId }
        });

      } else if (userType === 'PROFESSIONAL') {
        await this.CommonService.DeleteById(Tables.DentalProfessionals, userId);
        await this.CommonService.DeleteByCondition(Tables.Directories, {
          dental_professional_id: { _eq: userId }
        });
      }
      this.closeModal();
      this.spinner.hide();
      this.toast.openSnackBar("Your Account has been deleted Successfully");
      await this.logoutService.logout();
    } catch (err) {
      console.error("Error deleting records:", err);
    }
  }


    private loadUserProfile(): void {

      
    switch (this.loginDetails.type) {
      case "PROFESSIONAL":
        this.feedService.getUserProfileProfessional(this.loginDetails.id).subscribe(data => this.userData = data);
        this.basicInfoTabService.userProfDirectory(this.loginDetails.id).subscribe((data: any) => {
          if (Array.isArray(data) && data.length === 0 && this.userData.profile_completed === false) {
                        console.log('1111111111111111 ---PROFESSIONAL')

            this._dialog.open(IncomProfComponent, {
              width: '30%',
              scrollStrategy: this.overlay.scrollStrategies.noop(),
              panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
              disableClose: true,
              data: this.loginDetails,
            });
            // this.router.navigate(['/profile/detail']);
          }

          // Case 2: Profile completed but no directory found
          // else if (Array.isArray(data) && data.length === 0 && this.userData.profile_completed === true) {
          //   console.log('22222222222222 ---PROFESSIONAL')
            

          //   this._dialog.open(IncomProfComponent, {
          //     width: '30%',
          //     scrollStrategy: this.overlay.scrollStrategies.noop(),
          //     panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          //     disableClose: true,
          //     data: this.loginDetails,
          //   });

          //   this.router.navigate(['/profile/directory/add']);
          // }
        });

        break;

      case "SUPPLIER":
        this.feedService.getUserProfileSuplier(this.loginDetails.id).subscribe(data => this.userData = data);
                this.basicInfoTabService.userSupDirectory(this.loginDetails.id).subscribe((data: any) => {
          // Case 1: Profile not completed (check this first)
          if (Array.isArray(data) && data.length === 0 && this.userData.profile_completed === false) {
            console.log('11111111111111 ---SUPPLIER')
            this._dialog.open(IncomProfComponent, {
              width: '30%',
              scrollStrategy: this.overlay.scrollStrategies.noop(),
              panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
              disableClose: true,
              data: this.loginDetails,
            });

            // this.router.navigate(['/profile/detail']);
          }

          // Case 2: Profile completed but no directory found
          // else if (Array.isArray(data) && data.length === 0 && this.userData.profile_completed === true) {
          //   console.log('2222222222222222222 ---SUPPLIER')

          //   this._dialog.open(IncomProfComponent, {
          //     width: '30%',
          //     scrollStrategy: this.overlay.scrollStrategies.noop(),
          //     panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          //     disableClose: true,
          //     data: this.loginDetails,
          //   });

          //   this.router.navigate(['/profile/directory/add']);
          // }
        });
        

        break;

      case "PRACTICE":
        this.feedService.getUserProfilePracice(this.loginDetails.id).subscribe(data => this.userData = data);
                    this.basicInfoTabService.userPracDirectory(this.loginDetails.id).subscribe((data: any) => {
          // Case 1: Profile not completed (check this first)
          if (Array.isArray(data) && data.length === 0 && this.userData.profile_completed === false) {
            console.log('11111111111111 ---PRACTICE')

            this._dialog.open(IncomProfComponent, {
              width: '30%',
              scrollStrategy: this.overlay.scrollStrategies.noop(),
              panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
              disableClose: true,
              data: this.loginDetails,
            });

            // this.router.navigate(['/profile/detail']);
          }

          // Case 2: Profile completed but no directory found
          // else if (Array.isArray(data) && data.length === 0 && this.userData.profile_completed === true) {
          //   console.log('2222222222222222 ---PRACTICE')

          //   this._dialog.open(IncomProfComponent, {
          //     width: '30%',
          //     scrollStrategy: this.overlay.scrollStrategies.noop(),
          //     panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          //     disableClose: true,
          //     data: this.loginDetails,
          //   });

          //   this.router.navigate(['/profile/directory/add']);
          // }
        });
        break;
    }
  }

  ngAfterViewInit() {
    this.mapsAPILoader.load().then(() => {
      this.geoCoder = new google.maps.Geocoder();

      // 1️⃣ Autocomplete for user input
      if (this.addressSearchElementRef?.nativeElement) {
        const autocomplete = new google.maps.places.Autocomplete(this.addressSearchElementRef.nativeElement, {
          types: ['geocode'],
          componentRestrictions: { country: 'AU' }
        });

        autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
            const place: google.maps.places.PlaceResult = autocomplete.getPlace();

            if (!place.geometry || !place.geometry.location) {
              console.error('No geometry found for the selected place.');
              return;
            }

            const fullAddress = place.formatted_address || '';
            const components = place.address_components || [];
            const getComponent = (types: string[]) =>
              components.find(c => types.some(t => c.types.includes(t)))?.long_name || '';

            const streetNumber = getComponent(['street_number']);
            const route = getComponent(['route']);
            const addressLine1 = [streetNumber, route].filter(Boolean).join(' ').trim();
            let addressLine2 = getComponent(['sublocality_level_1', 'sublocality', 'neighborhood']);
            let landmark = getComponent(['sublocality_level_2']);
            if (!landmark) landmark = getComponent(['neighborhood']);
            if (!landmark) landmark = addressLine2;

            // Fallback for addressLine2 if empty
            if (!addressLine2 && addressLine1) {
              const streetIndex = fullAddress.indexOf(addressLine1);
              if (streetIndex > 0) {
                addressLine2 = fullAddress.substring(0, streetIndex).replace(/,\s*$/, '').trim();
                if (!landmark) landmark = addressLine2;
              }
            }

            const city = getComponent(['locality']);
            const state = getComponent(['administrative_area_level_1']);
            const postalCode = getComponent(['postal_code']);
            const country = getComponent(['country']);
            const latitude = place.geometry.location.lat();
            const longitude = place.geometry.location.lng();

            this.contactInformationForm.patchValue({
              address: fullAddress,
              address_line_one: addressLine1,
              address_line_two: addressLine2,
              land_mark: landmark,
              city,
              state,
              zipcode: postalCode,
              country,
              latitude,
              longitude
            });
          });
        });
      }
    });
  }
  // updateProfile() {
  // }


  //   submitDetails() {
  //   if (this.subscriberDetailForm.invalid) {
  //     this.toast.openSnackBar('Please fill required fields');
  //     return;
  //   }

  //   const formData = this.subscriberDetailForm.value;

  //   // CASE 1: Update (if token has an id)
  //   if (this.token?.id) {
  //     this.profileService.updateSubscriber(this.token.id, formData).then(success => {
  //       if (success) {
  //         this.toast.openSnackBar('Details updated successfully');
  //       } else {
  //         this.toast.openSnackBar('Failed to update details');
  //       }
  //     });
  //   } 
  //   // CASE 2: Add (new user, no token id)
  //   else {
  //     this.profileService.addSubscriber(formData).then(success => {
  //       if (success) {
  //         this.toast.openSnackBar('Details added successfully');
  //       } else {
  //         this.toast.openSnackBar('Failed to add details');
  //       }
  //     });
  //   }
  // }

  submitDetails() {
    const controls = this.subscriberDetailForm.controls;

    // Only check these specific fields
    const requiredFields = ['name', 'last_name', 'middle_name', 'date_of_birth', 'gender', 'salutation'];

    // Find which of these are invalid/missing
    const missingFields = requiredFields.filter(key => controls[key]?.invalid);

    if (missingFields.length > 0) {
      // console.log("❌ Missing fields:", missingFields);
      this.toast.openSnackBar(`Please fill required fields: ${missingFields.join(', ')}`);
      return;
    }

    let formData = this.subscriberDetailForm.value;

    if (this.token?.type === 'PROFESSIONAL') {
      // Remove fields not in dental_professionals_set_input
      delete formData.businessLogo;
      delete formData.businessName;
      delete formData.ABN_ACN_number;
      delete formData.profile_image;
    }


    if (this.token?.id) {
      this.profileService.updateSubscriber(this.token.id, formData).then(success => {
        this.toast.openSnackBar(success ? 'Details updated successfully' : 'Failed to update details');
      });
    }
  }


  submitProfessionalDetails() {
    const controls = this.professionalDetailsForm.controls;

    // List of fields to validate
    const requiredFields = [
      'profession_type',
      'pro_details_aphra_registration_number'
      // Add more fields if needed
    ];

    // Mark all fields as touched to show mat-errors
    requiredFields.forEach(field => controls[field]?.markAsTouched());

    const invalidFields = requiredFields.filter(field => controls[field]?.invalid);
    if (invalidFields.length > 0) {
      console.log('❌ Missing fields:', invalidFields);
      return; // stop submission
    }

    // Form is valid, prepare data
    const formData = this.professionalDetailsForm.value;
    console.log('✅ Professional Details Submitted:', formData);

    // Call your API/service here
    if (this.token?.id) {
      this.profileService.submitProfessionalDetails(this.token.id, formData)
        .then(success => {
          if (success) {
            this.toast.openSnackBar('Professional details updated successfully');
          } else {
            this.toast.openSnackBar('Failed to update professional details');
          }
        })
        .catch(err => {
          console.error(err);
          this.toast.openSnackBar('Something went wrong');
        });
    }
  }


  /* --------------------------------- Getters -------------------------------- */
  get phone(): AbstractControl {
    return this.signUpDetailsForm.get('phone');
  }
  get pro_details_aphra_registration_number() {
    return this.professionalDetailsForm.get('pro_details_aphra_registration_number');
  }
  get name(): AbstractControl {
    return this.signUpDetailsForm.get('name');
  }
  get bank_name(): AbstractControl {
    return this.otherDetailsForm.get('bank_name');
  }
  get account_holder_name(): AbstractControl {
    return this.otherDetailsForm.get('account_holder_name');
  }
  get account_number(): AbstractControl {
    return this.otherDetailsForm.get('account_number');
  }
  get bsb(): AbstractControl {
    return this.otherDetailsForm.get('bsb');
  }
  get businessPhoneNumber(): AbstractControl {
    return this.contactInformationForm.get('businessPhoneNumber');
  }
  get altEmail(): AbstractControl {
    return this.contactInformationForm.get('altEmail');
  }
  get altPhoneNo(): AbstractControl {
    return this.contactInformationForm.get('altPhoneNo');
  }
  get businessEmail(): AbstractControl {
    return this.contactInformationForm.get('businessEmail');
  }
  // get lName(): AbstractControl {
  //   return this.userForm.get('lName');
  // }
  // // get profileImage(): AbstractControl {
  // //   return this.userForm.get('profileImage');
  // // }
  // get phone(): AbstractControl {
  //   return this.userForm.get('phone');
  // }
  // get email(): AbstractControl {
  //   return this.userForm.get('email');
  // }
  // get password(): AbstractControl {
  //   return this.userForm.get('password');
  // }
  // get confirmPassword(): AbstractControl {
  //   return this.userForm.get('confirmPassword');
  // }
  // get altEmail(): AbstractControl {
  //   return this.userForm.get('altEmail');
  // }
  // get altPhone(): AbstractControl {
  //   return this.userForm.get('altPhone');
  // }
  // get addLine2(): AbstractControl {
  //   return this.userForm.get('addLine2');
  // }
  // get addLine1(): AbstractControl {
  //   return this.userForm.get('addLine1');
  // }
  // get landmark(): AbstractControl {
  //   return this.userForm.get('landmark');
  // }
  // get city(): AbstractControl {
  //   return this.userForm.get('city');
  // }
  // get state(): AbstractControl {
  //   return this.userForm.get('state');
  // }
  // get country(): AbstractControl {
  //   return this.userForm.get('country');
  // }
  // get zipCode(): AbstractControl {
  //   return this.userForm.get('zipCode');
  // }
  // get drivingLicense(): AbstractControl {
  //   return this.userForm.get('drivingLicense');
  // }
  // get regNumber(): AbstractControl {
  //   return this.userForm.get('regNumber');
  // }
  // get accountName(): AbstractControl {
  //   return this.userForm.get('accountName');
  // }
  // get bankName(): AbstractControl {
  //   return this.userForm.get('bankName');
  // }
  // get accountNumber(): AbstractControl {
  //   return this.userForm.get('accountNumber');
  // }
  // get profession_type(): AbstractControl {
  //   return this.userForm.get('profession_type');
  // }
  // get bsb(): AbstractControl {
  //   return this.userForm.get('bsb');
  // }
  checkBank() {
    this.userDisplay.second_hand = !this.userDisplay.second_hand
  }

  // Submit handler
  changeDetails() {
    this.spinner.show();

    const updatedName = this.signUpDetailsForm.value.name?.trim();
    const updatedPhone = this.signUpDetailsForm.value.phone?.trim();

    const phoneControl = this.signUpDetailsForm.get('phone');

    // Stop OTP if phone is invalid
    if (!this.phoneBlock && phoneControl?.invalid) {
      this.spinner.hide();
      return;
    }

    //  Only trigger OTP if phone is valid and changed
    if (!this.phoneBlock && phoneControl?.valid && updatedPhone && updatedPhone !== (this.token.phone || '').trim()) {
      this.phoneObj.email = this.token.email;
      this.phoneObj.type = this.token.type;
      this.updatePhone.phone = updatedPhone;

      this.profileService.checkData(this.phoneObj).then(data => {
        this.spinner.hide();
        this.statusMsg = data;
        if (this.statusMsg.status === 'success') {
          this._dialog.open(VerifyOtpComponent, {
            width: '30%',
            panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
            disableClose: true,
            data: { userData: this.phoneObj, updatedData: this.updatePhone, id: this.token.id }
          });
        } else {
          this.toast.openSnackBar('Phone update failed');
        }
      }).catch(err => {
        this.spinner.hide();
        console.error(err);
        this.toast.openSnackBar('Phone update failed');
      });
    }
    // Name changed → update directly (no OTP check)
    else if (!this.nameBlock && updatedName && updatedName !== (this.token.name || '').trim()) {
      this.updateName.name = updatedName;
      this.profileService.updateProf(this.token.id, this.updateName).then(success => {
        this.spinner.hide();
        if (success) {
          this.toast.openSnackBar('Name updated successfully');
          this.token.name = updatedName;
        } else {
          this.toast.openSnackBar('Failed to update name');
        }
      }).catch(err => {
        this.spinner.hide();
        console.error(err);
        this.toast.openSnackBar('Failed to update name');
      });
    } else {
      this.spinner.hide();
      this.toast.openSnackBar('No changes detected');
    }
  }

  async changeContact() {
    this.spinner.show()
    console.log(this.signUpDetailsForm.value)
    this.phoneObj.email = this.token.email
    this.phoneObj.type = this.token.type
    console.log(this.phoneObj)
    // altEmail:this.userDisplay.alt_email,
    // altPhoneNo:this.userDisplay.alt_phone,
    this.contactProf.alt_email = this.contactInformationForm.value.altEmail
    this.contactProf.alt_phone = this.contactInformationForm.value.altPhoneNo
    this.contactProf.address = this.contactInformationForm.value.address
    this.contactSupp.alt_email = this.contactInformationForm.value.altEmail
    this.contactSupp.alt_phone = this.contactInformationForm.value.altPhoneNo
    this.contactSupp.business_email = this.contactInformationForm.value.businessPhoneNumber
    this.contactSupp.business_phone = this.contactInformationForm.value.businessEmail

    this.contactSupp.secondary_name = this.contactInformationForm.value.contactName
    this.contactSupp.secondary_phone = this.contactInformationForm.value.phoneNoTwo
    this.contactSupp.secondary_email = this.contactInformationForm.value.emailTwo
    //this.updatePhone.phone = this.signUpDetailsForm.value.phone

    if (this.emailrequire == true) {
      this.profileService.checkData(this.phoneObj).then(data => {
        console.log(data)
        this.statusMsg = data
        if (this.statusMsg.status == 'success') {
          this.spinner.hide()
          if (this.token.type == "PROFESSIONAL") {
            this._dialog.open(VerifyOtpComponent, {
              width: '30%',
              panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
              disableClose: true,
              data: { userData: this.phoneObj, updatedData: this.contactProf, id: this.token.id }
            })
          } else {
            this._dialog.open(VerifyOtpComponent, {
              width: '30%',
              panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
              disableClose: true,
              data: { userData: this.phoneObj, updatedData: this.contactSupp, id: this.token.id }
            })
          }
        } else {
          this.spinner.hide()
          this.toast.openSnackBar(
            'You Failed'
          );
        }
      })
    } else {
      console.log('working');
      this.spinner.hide()
      if (this.token.type == "PROFESSIONAL") {

        this.profileService.updateProf(this.token.id, this.contactProf).then(data => {
          console.log(data)

          this.toast.openSnackBar(
            'Your Data Updated Successfully'
          );
        })

      }

      if (this.token.type == "SUPPLIER") {
        console.log(this.token.id)
        console.log(this.contactSupp)
        this.profileService.updateSupplier(this.token.id, this.contactSupp).then(data => {
          console.log(data)
          this.toast.openSnackBar(
            'Your Data Updated Successfully'
          );
        })

      }

      if (this.token.type == "PRACTICE") {

        this.profileService.updatePractice(this.token.id, this.contactSupp).then(data => {
          console.log(data)
          this.toast.openSnackBar(
            'Your Data Updated Successfully'
          );
        })

      }

    }
  }
  changeBank() {
    this.spinner.show()
    console.log(this.signUpDetailsForm.value)
    this.phoneObj.email = this.token.email
    this.phoneObj.type = this.token.type
    console.log(this.phoneObj)
    this.bankDetails.bank_details.bank_name = this.otherDetailsForm.value.bank_name
    this.bankDetails.bank_details.account_holder_name = this.otherDetailsForm.value.account_holder_name
    this.bankDetails.bank_details.account_number = this.otherDetailsForm.value.account_number
    this.bankDetails.bank_details.bsb = this.otherDetailsForm.value.bsb
    //this.bankDetails.bank_details.bsb = this.otherDetailsForm.value.sellSecondHandSupplies
    this.bankDetails.second_hand = this.otherDetailsForm.value.sellSecondHandSupplies
    //this.updatePhone.phone = this.signUpDetailsForm.value.phone
    this.profileService.checkData(this.phoneObj).then(data => {
      console.log(data)
      this.statusMsg = data
      if (this.statusMsg.status == 'success') {
        this.spinner.hide()
        this._dialog.open(VerifyOtpComponent, {
          width: '30%',
          panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          disableClose: true,
          data: { userData: this.phoneObj, updatedData: this.bankDetails, id: this.token.id }
        })
      }
      else {
        this.spinner.hide()
        this.toast.openSnackBar(
          'You Failed'
        );
      }
    })
  }
  openField() {
    this.phoneBlock = false
    this.phone.enable();
    this.emailrequire = true
  }

  openFieldName() {
    this.nameBlock = false;
    this.name.enable();

  }

  bankOne() {
    this.bankOneBlock = false
    this.bank_name.enable();
    this.emailrequire = true
  }
  bankTwo() {
    this.bankOneBlock = false
    this.account_holder_name.enable();
    this.emailrequire = true
  }
  bankThree() {
    this.bankOneBlock = false
    this.account_number.enable();
    this.emailrequire = true
  }
  bankFour() {
    this.bankOneBlock = false
    this.bsb.enable();
    this.emailrequire = true
  }
  altPhone() {
    this.conBlock = false
    this.altPhoneNo.enable();
    this.emailrequire = true
  }
  buzzEmail() {
    this.conBlock = false
    this.businessEmail.enable()
    this.emailrequire = true
  }
  altMail() {
    this.conBlock = false
    this.altEmail.enable()
    this.emailrequire = true
  }
  buzzPhone() {
    this.conBlock = false
    this.businessPhoneNumber.enable()
    this.emailrequire = true
  }
  onSelectFileDp(event) {

     if (!event || !event[0]) {
    return;
  }

    this.emailrequire = true
    this.spinner.show()
    console.log(event[0])
    const formData = new FormData();
    formData.append('directory', 'project');
    formData.append('file', event[0]);
    formData.append('Content-Type', 'application/json');
    formData.append('accept', 'application/json');
    console.log('formData,',formData)
    this.mediaService.uploadMedia(formData).subscribe(response => {
      console.log('response',response)
      this.spinner.hide()
      this.userPhoto = response
      if (this.userDisplay.type == "PROFESSIONAL") {
        this.profImage.profile_image = this.userPhoto
        this.profileService.updateUserImageProf(this.userDisplay.id, this.profImage)
      }
      if (this.userDisplay.type == "SUPPLIER") {
        this.suppImage.logo = this.userPhoto
        const status = this.profileService.updateUserImageSupplier(this.userDisplay.id, this.suppImage)
        if (status) {
          this.userDisplay.logo = this.userPhoto
        }
        // this.userDisplay.logo = this.userPhoto
      }
      if (this.userDisplay.type == "PRACTICE") {
        this.pracImage.logo = this.userPhoto
        this.profileService.updateUserImagePractice(this.userDisplay.id, this.pracImage)
      }
      // this.subscriberDetailForm.patchValue({
      //   userDp : response.url
      // })
    });
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const char = event.key;
    if (!/^[0-9]$/.test(char)) {
      event.preventDefault();
    }
  }

  allowOnlyCharacters(event: KeyboardEvent) {
    const char = event.key;
    if (!/^[a-zA-Z\s]*$/.test(char)) {
      event.preventDefault();
    }
  }

  async submitAllDetails() {
    this.spinner.show();

    try {
      if (!this.validateAllForms()) return;

      const updatedName = this.signUpDetailsForm.value.name?.trim();
      const updatedPhone = this.signUpDetailsForm.value.phone?.trim();
      const fullAddress = this.contactInformationForm.value.address || this.userDisplay?.address || '';
      const phoneControl = this.signUpDetailsForm.get('phone');

      // OTHER DETAILS UPDATE
      await this.handleOtherDetailsUpdate(fullAddress);

      // PHONE UPDATE (OTP FLOW)
      if (!this.phoneBlock && phoneControl?.valid && updatedPhone && updatedPhone !== (this.token.phone || '').trim()) {
        const phoneHandled = await this.handlePhoneUpdate(updatedPhone);
        if (!phoneHandled) return; // wait for OTP
      }

      // NAME UPDATE
      if (!this.nameBlock && updatedName && updatedName !== (this.token.name || '').trim()) {
        const nameUpdated = await this.handleNameUpdate(updatedName);
        if (nameUpdated) this.token.name = updatedName;
      }



    } catch (err) {
      console.error('Error in submitAllDetails:', err);
      this.toast.openSnackBar('Something went wrong updating details');
    } finally {
      this.spinner.hide();
    }
  }

  private validateAllForms(): boolean {
    if (!this.token) return false;

    // this.spinner.show();

    let isValid = true;
    let requiredMissing = false;
    const missingFields: string[] = [];

    if (this.token.type === 'PROFESSIONAL') {
      const fields = [
        this.signUpDetailsForm.get('name'),
        this.signUpDetailsForm.get('email'),
        this.signUpDetailsForm.get('phone'),
        this.contactInformationForm.get('address'),
        this.professionalDetailsForm.get('profession_type'),
        this.subscriberDetailForm.get('first_name') || this.subscriberDetailForm.get('name'),
        this.subscriberDetailForm.get('last_name'),
        this.subscriberDetailForm.get('gender'),
        this.subscriberDetailForm.get('date_of_birth'),
        this.subscriberDetailForm.get('salutation')
      ];
      fields.forEach(control => {
        if (!control?.value) {
          control?.markAsTouched();
          isValid = false;
          requiredMissing = true;

          // Get the control name
          const controlName = Object.keys(control.parent?.controls || {}).find(
            key => control.parent?.get(key) === control
          );
          if (controlName) missingFields.push(controlName);


        }
      });
    } else if (this.token.type === 'SUPPLIER' || this.token.type === 'PRACTICE') {
      const fields = [
        this.signUpDetailsForm.get('name'),
        this.signUpDetailsForm.get('email'),
        this.signUpDetailsForm.get('phone'),

        this.subscriberDetailForm.get('businessName'),
        this.subscriberDetailForm.get('ABN_ACN_number'),

        this.contactInformationForm.get('address'),
        this.contactInformationForm.get('lName'),
        this.contactInformationForm.get('fName'),
        this.contactInformationForm.get('altPhoneNo'),
        this.contactInformationForm.get('altEmail'),

        this.professionalDetailsForm.get('profession_type'),


      ];


      fields.forEach(control => {
        if (!control) return;

        // Skip optional fields for required check
        if (control !== this.contactInformationForm.get('altEmail') &&
          control !== this.contactInformationForm.get('altPhoneNo')) {
          if (!control.value) {
            control.markAsTouched();
            isValid = false;
            requiredMissing = true;

            // Try to get the control name from form group
            const controlName = Object.keys(control.parent?.controls || {}).find(
              key => control.parent?.get(key) === control
            );
            if (controlName) missingFields.push(controlName);

          }
        }

        // Optional fields: validate only if they have a value
        if ((control === this.contactInformationForm.get('altEmail') ||
          control === this.contactInformationForm.get('altPhoneNo')) &&
          control.value) {
          if (control.invalid) {
            control.markAsTouched();
            isValid = false;

            if (control === this.contactInformationForm.get('altEmail')) {
              this.toast.openSnackBar('Please enter a valid alternate email address');
            } else {
              this.toast.openSnackBar('Please enter a valid alternate phone number');
            }
          }
        }
      });

    }

    if (requiredMissing) {
      console.warn('Missing required fields:', missingFields);
      this.toast.openSnackBar('Please fill all required fields');
    }

    // this.spinner.hide();
    return isValid;
  }

  private async handleOtherDetailsUpdate(fullAddress: string): Promise<void> {
    if (!this.token) return;

    try {
      if (this.token.type === 'PROFESSIONAL') {

        const professionalUpdateObj = {
          // SignUp form
          name: this.signUpDetailsForm.get('name')?.value,
          email: this.signUpDetailsForm.get('email')?.value,
          phone: this.signUpDetailsForm.get('phone')?.value,

          // Address
          address: fullAddress,

          // Professional Details
          profession_type: this.professionalDetailsForm.get('profession_type')?.value,
          pro_details_aphra_registration_number: this.professionalDetailsForm.get('pro_details_aphra_registration_number')?.value,

          // Subscriber details
          first_name: this.subscriberDetailForm.get('first_name')?.value || this.subscriberDetailForm.get('name')?.value,
          last_name: this.subscriberDetailForm.get('last_name')?.value,
          middle_name: this.subscriberDetailForm.get('middle_name')?.value,
          gender: this.subscriberDetailForm.get('gender')?.value,
          date_of_birth: this.subscriberDetailForm.get('date_of_birth')?.value,
          salutation: this.subscriberDetailForm.get('salutation')?.value,

          profile_completed: true

        };

        const professionalSuccess = await this.profileService.updateDentalProfessionalCombined(
          this.token.id,
          professionalUpdateObj
        );

        if (professionalSuccess) {
          const loginData = this.sls.get('loginData');

          const updatedLoginData = {
            ...loginData,
            profile_completed: true
          };

          this.sls.set('loginData', updatedLoginData);

          // Navigate after updating localStorage

           if (!updatedLoginData.directory_category_id) {
            this.router.navigate(['/profile/directory/add']);
          }

          // this.router.navigate(['/profile/directory/add']);

        }

        this.toast.openSnackBar(
          professionalSuccess ? 'Profile updated successfully' : 'Failed to update details'
        );

      } else if (this.token.type === 'SUPPLIER' || this.token.type === 'PRACTICE') {

        const baseUpdateObj = {

          name: this.signUpDetailsForm.get('name')?.value,
          email: this.signUpDetailsForm.get('email')?.value,
          phone: this.signUpDetailsForm.get('phone')?.value,

          business_name: this.subscriberDetailForm.get('businessName')?.value,
          abn_number: this.subscriberDetailForm.get('ABN_ACN_number')?.value,

          address: fullAddress,

          first_name: this.contactInformationForm.get('fName')?.value || this.subscriberDetailForm.get('name')?.value,
          last_name: this.contactInformationForm.get('lName')?.value,
          middle_name: this.contactInformationForm.get('mName')?.value,
          fax_number: this.contactInformationForm.get('faxNumber')?.value,
          alt_email: this.contactInformationForm.get('altEmail')?.value,
          alt_phone: this.contactInformationForm.get('altPhoneNo')?.value,

          profession_type: this.professionalDetailsForm.get('profession_type')?.value,


          profile_completed: true
        };


        let updateSuccess = false;

       if (this.token.type === 'SUPPLIER') {
  const supplierUpdateObj = { ...baseUpdateObj };
  updateSuccess = await this.profileService.updateSupplier(this.token.id, supplierUpdateObj);

  // Now update client table using same ID
  if (updateSuccess && this.clientId) {
    const clientUpdatePayload = {
      type: this.token.type,
      business_name: this.subscriberDetailForm.get('businessName')?.value,
      name: this.signUpDetailsForm.get('name')?.value,
      email: this.signUpDetailsForm.get('email')?.value,
      phone: this.signUpDetailsForm.get('phone')?.value,
      state: this.subscriberDetailForm.get('state')?.value,
      postal_code: this.subscriberDetailForm.get('zipcode')?.value,
      professionType: this.professionalDetailsForm.get('profession_type')?.value,
    };

    await this.profileService.updateClientFromSupplier(this.clientId, clientUpdatePayload);
  }
}

 else if (this.token.type === 'PRACTICE') {
          const practiceUpdateObj = { ...baseUpdateObj };
          console.log('Practice update payload:', practiceUpdateObj);
          updateSuccess = await this.profileService.updatePractice(this.token.id, practiceUpdateObj);
        }

        //  Update localStorage like we did for PROFESSIONAL
        if (updateSuccess) {
          const loginData = this.sls.get('loginData');
          const updatedLoginData = {
            ...loginData,
            profile_completed: true
          };
          this.sls.set('loginData', updatedLoginData);

          // Optional: navigate somewhere if needed
          if(!updatedLoginData.directory_category_id  ){
                this.router.navigate(['/profile/directory/add']);
          }


        }

        this.toast.openSnackBar(
          updateSuccess
            ? `${this.token.type.charAt(0)}${this.token.type.slice(1).toLowerCase()} profile updated successfully`
            : `Failed to update ${this.token.type.toLowerCase()} profile`
        );

      }

    } catch (err) {
      console.error('Error while updating profile:', err);
      this.toast.openSnackBar('Failed to update profile');
    }
  }

  //  this.router.navigate(['/profile/directory/add']);

  private async handlePhoneUpdate(updatedPhone: string): Promise<boolean> {
    this.phoneObj.email = this.token.email;
    this.phoneObj.type = this.token.type;
    this.updatePhone.phone = updatedPhone;

    try {
      const data = await this.profileService.checkData(this.phoneObj);
      this.statusMsg = data;
      this.spinner.hide();

      if (this.statusMsg.status === 'success') {
        const dialogRef = this._dialog.open(VerifyOtpComponent, {
          width: '30%',
          panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          disableClose: true,
          data: { userData: this.phoneObj, updatedData: this.updatePhone, id: this.token.id }
        });

        dialogRef.afterClosed().subscribe(async (otpSuccess: boolean) => {
          if (otpSuccess) {
            this.spinner.show();
            const phoneUpdated = await this.profileService.updateDentalProfessionalCombined(this.token.id, { phone: updatedPhone });
            this.toast.openSnackBar(phoneUpdated ? 'Phone updated successfully' : 'Failed to update phone');
            if (phoneUpdated) this.token.phone = updatedPhone;
            this.spinner.hide();
          }
        });
        return false; // wait for OTP before continuing
      } else {
        this.toast.openSnackBar('Phone update failed');
        return false;
      }

    } catch (err) {
      console.error(err);
      this.toast.openSnackBar('Phone update failed');
      this.spinner.hide();
      return false;
    }
  }

  private async handleNameUpdate(updatedName: string): Promise<boolean> {
    try {
      const nameUpdated = await this.profileService.updateProf(this.token.id, { name: updatedName });
      if (nameUpdated) this.token.name = updatedName;
      return nameUpdated;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  selectProfessionType() {
    const dialogRef = this._dialog.open(SelectProfessionTypeComponent, {
      width: '45%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      disableClose: true,
      data: {
        selected: this.professionalDetailsForm.value.profession_type || '',
        busineesTypes: this.busineesTypes
      }
    });

    dialogRef.afterClosed().subscribe((selectedProfession: any) => {
      if (selectedProfession) {
        //  ensure it's a string
        const professionValue = typeof selectedProfession === 'string'
          ? selectedProfession
          : selectedProfession.name || selectedProfession.selected || '';

        this.professionalDetailsForm.patchValue({
          profession_type: professionValue
        });
      }
    });
  }

}
